
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function usePackkySetting() {
  const { baseurl, token, accessToken, setIsUnauthorised } = useGlobalContext();

  const headers = {
    Authorization: `Basic ${token}`,
    "Content-Type": "application/json",
    ...(accessToken ? { "x-access-token": accessToken } : {}),
  };

  // --------- 1) FETCH OFFERS ----------
  const fetchOffersApi = async (setOffers, setLoading, silent = false) => {
    if (!silent) setLoading(true);

    try {
      const payload = { userid: "" };

      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/getAllDriverOffers`,
        payload,
        { headers }
      );

      if (res?.data?.responseCode === "00") {
        const list = Array.isArray(res.data.response)
          ? res.data.response
          : Array.isArray(res.data.data)
          ? res.data.data
          : [];

        setOffers(list);
      } else if (res?.data?.responseCode === "401") {
        setIsUnauthorised?.(true);
      } else {
        toast.error(res?.data?.responseMessage || "Failed to fetch offers");
      }
    } catch {
      toast.error("Error fetching offers");
    } finally {
      if (!silent) setLoading(false);
    }
  };

  // --------- 2) CREATE OFFER ----------
  const createOfferApi = async (body, setLoading, onSuccess) => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/insertDriverOffers`,
        body,
        { headers }
      );

      if (res?.data?.responseCode === "00") {
        toast.success("Offer created");
        onSuccess?.();
      } else if (res?.data?.responseCode === "401") {
        setIsUnauthorised?.(true);
      } else {
        toast.error(res?.data?.responseMessage || "Failed to create offer");
      }
    } catch {
      toast.error("Error creating offer");
    } finally {
      setLoading(false);
    }
  };

  // --------- 3) DELETE OFFER ----------
  const deleteOfferApi = async (offerId, setLoading, onSuccess) => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/deleteDriverOffers`,
        { offerid: String(offerId) },
        { headers }
      );

      if (res?.data?.responseCode === "00") {
        toast.success("Offer deleted");
        onSuccess?.();
      } else if (res?.data?.responseCode === "401") {
        setIsUnauthorised?.(true);
      } else {
        toast.error(res?.data?.responseMessage || "Failed to delete offer");
      }
    } catch {
      toast.error("Error deleting offer");
    } finally {
      setLoading(false);
    }
  };

  // --------- 4) ADD INCENTIVE ----------
  const addIncentiveApi = async (body, setLoading, onSuccess) => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/insertDriverOffersIncentive`,
        body,
        { headers }
      );

      if (res?.data?.responseCode === "00") {
        toast.success("Incentive added");
        onSuccess?.();
      } else if (res?.data?.responseCode === "401") {
        setIsUnauthorised?.(true);
      } else {
        toast.error(res?.data?.responseMessage || "Failed to add incentive");
      }
    } catch {
      toast.error("Error adding incentive");
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchOffersApi,
    createOfferApi,
    deleteOfferApi,
    addIncentiveApi,
  };
}
